export enum StorageKeys {
  AUTH_TOKEN = 'auth_token',
  USER = 'user',
  JOURNAL_ENTRIES = 'journal_entries',
  JOURNAL_DRAFTS = 'journal_drafts', // Ajout de la clé pour les brouillons
  ACCOUNTS = 'accounts',
  SETTINGS = 'settings',
  ORGANIZATION = 'organization',
  SYNC_QUEUE = 'sync_queue'
}